import React from 'react';
import './Loader.css';
import { useTranslation } from '../i18n';

// Indicateur de chargement (roue + texte), le temps que les API FFTT répondent
// compact : version réduite pour les petits blocs (cartes de l'accueil)
function Loader({label, compact = false}) {
    const { t } = useTranslation();
    return (
        <div className={"loader_component" + (compact ? " compact" : "")} role="status" aria-live="polite">
            <span className="loader_spinner" aria-hidden="true" />
            <span className="loader_label">{label || t('common.loading')}</span>
        </div>
    );
}

export default Loader;
